export default __webpack_public_path__ + "static/media/opel_offer2.7b211025.jpg";